import React, { useState, useEffect, useRef } from "react";
import notfound from '../../../Assets/images/il-empty.svg';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import ModalLog from "./ModalLog";
import { usePagination, useSortBy, useTable} from 'react-table';
import ModalEliminarInforme from "./ModalEliminarInforme";
import PaginationComponent from "../../../Components/PaginationTableServer/PaginationTableServer";
import ModalAprobarInforme from "./ModalAprobarInforme";
import useLogin from "../../Autenticacion/Hooks/useLogin";

const SinInformarTable = ({fetchData, columns, data, pageCount: controlledPageCount, currentpage, pageSize: controlledPageSize, sortBy: controlledSortBy, setPagination, showEliminar, setShowEliminar, showAprobar, setShowAprobar, valoresFormularioEnvio }) => {
  const [showModal, setShowModal] = useState(false);
  const [datosModal, setDatosModal] = useState(null);
  const { usuario } = useLogin();
  const primerRenderizado = useRef(true);

  const handleShowModal = (values) => {
    setDatosModal(values);
    setShowModal(true);
  }
  
  const handleCloseModal = () => setShowModal(false);

  const handleShowEliminar = (values) => {
    setDatosModal(values);
    setShowEliminar(true);
  }

  const handleCloseEliminar = () => setShowEliminar(false);

  const handleShowAprobar = (values) => {
    setDatosModal(values);
    setShowAprobar(true);
  }
  
  const handleCloseAprobar = () => setShowAprobar(false);

  const {getTableProps, getTableBodyProps, headerGroups, prepareRow, page, pageCount, gotoPage, setSortBy, state: { pageIndex, pageSize, sortBy }} 
	= useTable(
		{
			columns
			, data
			, initialState: { pageIndex: currentpage, pageSize: controlledPageSize, sortBy: controlledSortBy }
			, manualPagination: true
			, pageCount: controlledPageCount
			, autoResetPage: false
			, autoResetSortBy: false
			, manualSortBy: true
		},
		useSortBy
		, usePagination
	)

  useEffect(() => {
    if (primerRenderizado.current) {
      primerRenderizado.current = false;
      return;
    }

    fetchData({ formulario: valoresFormularioEnvio, pageIndex, sortBy });
    setPagination(values => ({
      ...values,
      sortBy: sortBy
    }));
}, [pageIndex, sortBy]);

  return (
    <div className='accordion-body p-0 brd-top'>
      <div style={{ overflow: "auto"}}>
        <table className="table table-sm" {...getTableProps()} style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
              {headerGroups.map((headerGroup) => {
              const { key: hgKey, ...hgProps } = headerGroup.getHeaderGroupProps();
              return <tr key={hgKey} {...hgProps}>
                {headerGroup.headers.map((column) => {
                const { key, ...restProps } = column.getHeaderProps(
                  column.getSortByToggleProps(),
                  { className: column.className }
                );

                return data.length > 0 ? (
                  <th key={key} {...restProps}>
                  <span className="d-flex align-items-center gap-1">
                    {column.render("Header")}
                    <>
                    {column.isSorted ? (
                      column.isSortedDesc && data.length > 0 ? (
                      <i className="ico-chevron-down"></i>
                      ) : (
                      <i className="ico-chevron-up"></i>
                      )
                    ) : (
                      <>
                      <i className="ico-sort fs-7"></i>
                      </>
                    )}
                    </>
                  </span>
                  </th>
                ) : (
                  <th key={key} {...restProps}>
                  <span className="d-flex align-items-center gap-1">
                    {column.render("Header")}
                  </span>
                  </th>
                );
              })}
              <th className="text-center">Acciones</th>
              </tr>
              })}
            </thead>
            <tbody {...getTableBodyProps()}>
            {
                page.length > 0 && page.map( (row) => {
                  prepareRow(row)
                  const { key: rowKey, ...rowProps } = row.getRowProps();
                  return (
                    <tr key={rowKey} {...rowProps}>
                      {row.cells.map((cell) => {
                        const { key: tdKey, ...tdProps } = cell.getCellProps({
                          className: cell.column.className
                        });
                        return <td key={tdKey} {...tdProps}>
                          {cell.render('Cell')}
                        </td>
                      })}
                        <td className="text-center d-flex justify-content-center gap-2">
                          { row.original.estado === 2 ? (
                            <>
                              <OverlayTrigger
                                overlay={<Tooltip id="tooltip-top">Ver Log</Tooltip>}
                              >
                                <button                    
                                  className="link text-pewter-blue fs-4"  
                                  onClick={() => handleShowModal(row.original)}
                                  disabled={row.original.estado === 1 || row.original.estado === 4} 
                                >
                                  <i className="ico-doc-search m-md-1"></i>
                                </button>
                              </OverlayTrigger>
                            </>
                          ) : (
                            <>
                              <OverlayTrigger
                                overlay={<Tooltip id="tooltip-top">Informar Archivo</Tooltip>}
                              >
                                <button 
                                  className="link text-pewter-blue fs-4" 
                                  onClick={() => handleShowAprobar(row.original)} 
                                  disabled={row.original.estado === 1 || row.original.estado === 4 || `${row.original.usuarioCarga.nombres} ${row.original.usuarioCarga.apellidoPaterno}` !== `${usuario.nombres} ${usuario.apellidoPaterno}`}
                                >
                                  <i className="ico-doc-edit m-md-1"></i>
                                </button>
                              </OverlayTrigger>
                            </>
                          )}
                          <OverlayTrigger
                            overlay={<Tooltip id="tooltip-top">Borrar Archivo</Tooltip>}
                          >
                            <button 
                              className="link text-pewter-blue fs-4" 
                              onClick={() => handleShowEliminar(row.original)}
                              disabled={row.original.estado === 1 || row.original.estado === 4 || `${row.original.usuarioCarga.nombres} ${row.original.usuarioCarga.apellidoPaterno}` !== `${usuario.nombres} ${usuario.apellidoPaterno}`}
                            >
                              <i className="ico-close m-md-1"></i>
                            </button>
                          </OverlayTrigger>
                        </td>
                    </tr>
                    )
                }) || <tr><td colSpan={headerGroups[0].headers.length + 1}>
                <div className="d-flex justify-content-center align-items-center flex-column gap-2 py-5">
                  <img className="mb-3" src={notfound} alt=""/>
                  <p className='mb-0 text-primary'>No se encuentran resultados de tu búsqueda.</p>
                </div>
              </td></tr>
              }
              
            </tbody>
          
        </table>
      </div>

      {
				page.length > 0 &&
				<PaginationComponent
					pagesCountServer={pageCount}
					currentPage={pageIndex}
					setCurrentPage={gotoPage}
					alwaysShown={true}
					setPagination={setPagination}
				/>
			}


      {
        showModal?
        <ModalLog
          show={showModal}
          onHide={handleCloseModal}
          datosModal={datosModal}
        />
        :null
      }

      <ModalEliminarInforme
				show={showEliminar}
				onHide={handleCloseEliminar}
        datosModal={datosModal}
			/>

      <ModalAprobarInforme
        show={showAprobar}
        onHide={handleCloseAprobar}
        datosModal={datosModal}
      />
    </div>
  );
};

export default SinInformarTable;
